import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref, watch } from "vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import OfferCardDescription from "@/components/offers/offer/OfferCardDescription.vue";

interface Props {
    offer: OfferSingle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferTexts',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle;
}


const isLoading = ref(false);
const descrList = ref([
    [
        {
            name: 'Описание - RU',
            key: "description_ru",
            tooltip: "Отображается в русской версии ЛК партнёра.",
            value: "",
            isCollapse: true,
            isShort: false,
        },
        {
            name: 'Описание - EN',
            key: "description_en",
            tooltip: "Отображается в английской версии ЛК партнёра.",
            value: "",
            isCollapse: true,
            isShort: false,
        },
    ],
    [
        {
            name: 'Краткое описание - RU',
            key: "short_description_ru",
            tooltip: "Отображается на русской версии сайта cpa.leadgid",
            value: "",
            isCollapse: false,
            isShort: true,
        },
        {
            name: 'Краткое описание - EN',
            key: "short_description_en",
            tooltip: "Отображается на английской версии сайта cpa.leadgid",
            value: "",
            isCollapse: false,
            isShort: true,
        },
    ],
    [
        {
            name: 'Плюсы',
            key: "advantages",
            tooltip: "Отображается на русской версии сайта cpa.leadgid",
            value: "",
            isCollapse: false,
            isShort: false,
        },
        {
            name: 'Минусы',
            key: "disadvantages",
            tooltip: "Отображается на русской версии сайта cpa.leadgid",
            value: "",
            isCollapse: false,
            isShort: false,
        },
    ],
]);

onBeforeMount(() => {
    updateDescrList();
});

const updateDescrList = () => {
    descrList.value.forEach((row) => {
        row.forEach((item) => {
            item.value = props.offer[item.key] || '';
        });
    });
};

watch(() => props.offer, () => {
    updateDescrList();
}, { deep: true });


return { __sfc: true,props, isLoading, descrList, updateDescrList, OfferCardDescription }
}

})